import * as React from 'react';

import { DropdownMenu, IDropdownMenuLink } from '../../components/DropdownMenu';
import { TDropdownType } from '../../components/DropdownMenu/interfaces';
import { IOtherLinksSchema } from '../../repositories/header/entities/other_links/OtherLinksSchema';

export interface IDropdownMenuContainerState {
  hasShadow?: boolean;
  links: IDropdownMenuLink[];
  show: boolean;
}

export interface IDropdownMenuContainerProps {
  catalogDevelopersUrl?: string;
  isOpen?: boolean;
  links: IDropdownMenuLink[];
  name: TDropdownType;
  onClose?(): void;
  onMouseLeave?(key: string): void;
  otherLinks?: IOtherLinksSchema | null;
}

export class DropdownMenuContainer extends React.Component<IDropdownMenuContainerProps, IDropdownMenuContainerState> {
  public constructor(props: IDropdownMenuContainerProps) {
    super(props);

    const { links } = props;

    this.state = {
      hasShadow: false,
      links,
      show: true,
    };
  }

  public componentDidMount() {
    const { name } = this.props;

    this.setState({
      hasShadow: window.___header_serpPageType !== name,
    });
  }

  public render() {
    const { catalogDevelopersUrl, isOpen, name, onClose, onMouseLeave, otherLinks } = this.props;
    const { hasShadow, links } = this.state;

    const linksOther = otherLinks || ({} as IOtherLinksSchema);

    return (
      <DropdownMenu
        catalogDevelopersUrl={catalogDevelopersUrl}
        hasShadow={hasShadow}
        isOpen={isOpen}
        links={links}
        name={name}
        onClose={onClose}
        onMouseLeave={onMouseLeave}
        otherLinks={linksOther}
      />
    );
  }
}
